import { ReactNode } from "react"
import DashboardTopbar from "@/components/DashboardTopbar"
import { usePage } from "@inertiajs/react"
import { EventShowProps } from "@/types/types"
import AppLayout from "@/layouts/AppLayout"
import ActionBar from "@/components/event/ActionBar"
import GamesList from "@/components/event/GamesList"
import DeleteEventModal from "@/modals/DeleteEventModal"
import ShareModal from "@/modals/ShareModal"
import EditEventModal from "@/modals/EditEventModal"

const EventShowPage = () => {
  const { event, isOwner } = usePage<EventShowProps>().props

  return (
    <>
      <DashboardTopbar title={event.name}>
        {isOwner && <ActionBar event={event} />}
      </DashboardTopbar>

      <main>
        <GamesList games={event.games} />
      </main>

      {isOwner && (
        <>
          <EditEventModal event={event} />
          <DeleteEventModal event={event} />
          <ShareModal
            title="Share event"
            url={`https://chessdrop.com/events/${event.id}`}
            type="event"
          />
        </>
      )}
    </>
  )
}

export default EventShowPage

EventShowPage.layout = (page: ReactNode) => <AppLayout>{page}</AppLayout>
